import React, { useState ,useEffect} from 'react';
import Project from "./Project.js"
import { images } from './data'
import "./css/Projects.css"
import AOS from 'aos';
import Footer from "./Footer.js"

import Next from "./Next.js"
import 'aos/dist/aos.css'; // You can also use <link> for styles
function Projects() {
    AOS.init();
  
    const url="https://api.github.com/users/ennkaos"
    const url2="https://api.github.com/users/ennkaos/repos"
    const [loading,setLoading]=useState(true)
    const [data,setData]=useState([])
    const [image,setImages]=useState([])
    const [repo,setRepo]=useState([])
    const [repoState,setRepoState]=useState(false)
      
    
    const fetchData= async ()=>{
      const response= await fetch(url);
      const dataUser= await response.json()
      setLoading(false)
      setData(dataUser)
      setImages(images)
    }
   
  const fetchData2= async ()=>{
      const response2= await fetch(url2);
      const dataUser2= await response2.json()
      
      setRepo(dataUser2)
    }
    
     useEffect(() => {
      fetchData()
      fetchData2()
     }, [])
    if(loading){
     
      return <section className="section-center"> 
        <h2>Loading...</h2>
      </section>
    }
    
    
    
    const {login,avatar_url,html_url,description,language}=data;
   
    return (
        <>
    <section className="section-center">
   
      <main data-aos="fade-up"  
            data-aos-duration="3000" >
          
          
          <img className="img" src={avatar_url} alt={login}/>
          <h1>{login}</h1>
          <div className="underline"></div>
          <p className="link"><a href={html_url}>Link to GitHub Profile</a></p>
          <button onClick={()=>setRepoState(!repoState)} className="btn">{repoState? "Hide Projects":"Show Projects"}</button>
          {repoState?
          <div   
           className="container">
            {repo.map((item,index)=>{
                const {id}=repo[index];
                const {src}= image[index]
                
                return <Project key={id} language={language} description={description} location={src}  name={item.name} created_at={item.created_at} clone_url={item.clone_url} {...item} />
            })}
          </div>:<div></div>
          }
          
      </main>
     
    </section>
          <Next islast={true} name="Experience" back="AboutMe" href2="/" isAbout={true} href="/experience"/>
        <Footer/>    
    </>
      )
}

export default Projects
